import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ReferenceParams, Res, UserRoleReference } from 'src/app/models';
import { LanguageService, NotificationService } from 'src/app/services';
import { ApiNotificationsService } from 'src/app/services/api-notifications.service';

@Component({
  selector: 'app-notifications-roles-settings-actions',
  templateUrl: './notifications-roles-settings-actions.component.html',
  styleUrls: ['./notifications-roles-settings-actions.component.css']
})
export class NotificationsRolesSettingsActionsComponent implements OnInit {


  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  notificationId: string;
  notificationData: any;
  language: string;
  loading: boolean;
  types: any[] = [];
  errorMessages: any;
  uroles: UserRoleReference[];

  form: UntypedFormGroup = this.fb.group({
    id: [null],
    type: [null]
  });

  @Input() set data(value) {

    if (value != null) {

      this.notificationId = value.notifications_id;

    }
  }

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private apiNotifications: ApiNotificationsService,
    public activeModal: NgbActiveModal,
    private notification: NotificationService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.getNotificationTypes();
    this.getRoles();

    if (this.notificationId) {

      this.onEdit();
    }

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  /**
  * 
  */
  getNotificationTypes(): void {

    let params: ReferenceParams = {
      ref_name: 'notification_types',
      filter: {

      }
    }

    this.subscriptions.add(
      this.apiNotifications.getReferences(params, params.ref_name).subscribe((response: Res) => {

        if (response != null) {

          this.types = response.result;

        }
      })
    );
  }

  /**
  * 
  */
  getRoles(): void {

    let params: ReferenceParams = {
      ref_name: 'uroles_in_orgs',
      // filter: {
      //   org_id: this.org_id
      // }
    }

    this.subscriptions.add(
      this.apiNotifications.getReferences(params, params.ref_name).subscribe((response: Res) => {

        if (response != null) {

          this.uroles = response.result;
        }
      })
    );
  }

  /**
   * 
   */
  onCreate(): void {

    let form = { ...this.form.value }

    this.progressRef.start();

    console.log("FORM: ", form);


    this.subscriptions.add(
      this.apiNotifications.createNotificationsUserRoles(form).subscribe((response: Res) => {
        console.log('[RESPONSE] CREATE_CHANNEL: ', response);

        if (response != null) {

          this.notification.show('success', 'Настройки успешно сохранены!');
          this.activeModal.close(response);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
  * 
  */
  onEdit(): void {

    this.progressRef.start();
    this.loading = true;

    this.subscriptions.add(

      this.apiNotifications.editNotificationsUserRoles(this.notificationId).subscribe((response: Res) => {
        console.log('[RESPONSE] ATTR_EDIT: ', response);

        if (response != null) {

          this.notificationData = { ...response.result };

          this.setDataInForm(response.result);
        }
        this.progressRef.complete();
        this.loading = false;
      },
        error => {
          this.progressRef.complete();
          this.loading = false;
        })
    );
  }

  /**
   * 
   */
  setDataInForm(data: any): any {

    this.form.controls.id.setValue(data.id);
    this.form.controls.notification_type.setValue(data.notification_type);
    this.form.controls.urole_id.setValue(data.urole_id);
  }

  /**
   * 
   */
   onUpdate() {

    let form = { ...this.form.value }

    this.progressRef.start();

    this.subscriptions.add(
      this.apiNotifications.updateNotificationsUserRoles(form).subscribe((response: Res) => {
        console.log('[RESPONSE] UPDATE_CHANNEL: ', response);

        if (response != null) {

          this.notification.show('success', 'Данные успешно сохранены!');
          this.activeModal.close(response);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

}
